import { render, staticRenderFns } from "./InspectionDetail.vue?vue&type=template&id=e1600c94&scoped=true"
import script from "./InspectionDetail.vue?vue&type=script&lang=js"
export * from "./InspectionDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionDetail.vue?vue&type=style&index=0&id=e1600c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1600c94",
  null
  
)

export default component.exports